import type { GroupBase, MultiValueProps, OptionProps, SelectComponentsConfig } from "react-select";
import { Userdata } from "@/types/user";
import { Avatar, AvatarImage } from "@/components/ui/avatar";
import { createBase64Image, defaultUserAvatar } from "@/helpers/images";

export const SelectComponents: SelectComponentsConfig<Userdata, true, GroupBase<Userdata>> = {
  Option: (props: OptionProps<Userdata, true, GroupBase<Userdata>>) => (
    <div className="flex cursor-pointer px-3 py-1 align-middle text-sm" ref={props.innerRef} {...props.innerProps}>
      <Avatar className="mr-2 h-5 w-5">
        <AvatarImage
          src={props.data.avatar ? createBase64Image(props.data.avatar) : defaultUserAvatar}
          alt={props.data.name || "User"}
        />
      </Avatar>
      <div>
        {props.data.name} {props.data.surname} ({props.data.email})
      </div>
    </div>
  ),
  MultiValue: (props: MultiValueProps<Userdata, true, GroupBase<Userdata>>) => (
    <div
      className="m flex cursor-pointer rounded bg-gray-100 px-3 py-1 align-middle text-sm"
      {...props.innerProps}
      onClick={props.clearValue}
    >
      <Avatar className="mr-2 h-5 w-5">
        <AvatarImage
          src={props.data.avatar ? createBase64Image(props.data.avatar) : defaultUserAvatar}
          alt={props.data.name || "User"}
        />
      </Avatar>
      <div>
        {props.data.name} {props.data.surname} ({props.data.email})
      </div>
    </div>
  ),

  NoOptionsMessage: () => <div className="text-center text-sm">No data</div>,
};
